module.exports = __webpack_public_path__ + "img/8.76c27862.jpg";